// Bare Custom API endpoint names. ApiService prefixes these with the host + tenant
// segments from environment, so paths are never hardcoded in a service.
export enum EApiPath {
  // Auth
  LOGIN = 'login',
  REFRESH_TOKEN = 'refresh-token',

  // Reference data
  LOOKUPS = 'lookups',

  // Customers
  CUSTOMERS = 'customers',
  CUSTOMER_STATEMENT = 'customer-statement',
  CUSTOMER_PRODUCT_PRICE = 'customer-product-price',

  // Invoice settings
  INVOICE_SETTINGS = 'invoice-settings',
  UPDATE_INVOICE_SETTINGS = 'update-invoice-settings',

  // Orders
  CREATE_ORDER = 'create-order',
  DELETE_ORDER = 'delete-order',
  ORDER_HISTORY = 'order-history',
  // Un-booked estimates. Every other order endpoint hides these (rule #1), so the
  // quotations screen needs its own list endpoint rather than a filter on history.
  QUOTATIONS = 'quotations',
  JOBSHEET = 'jobsheet',
  ORDER_SUMMARY = 'order-summary',
  UPDATE_ORDER_ITEM_STATUS = 'update-order-item-status',
  RECORD_PAYMENT = 'record-payment',
  SEND_PAYMENT_REMINDER = 'send-payment-reminder',

  // Invoicing
  INVOICE = 'invoice',
  SET_ORDER_DISCOUNT = 'set-order-discount',
  GENERATE_INVOICE = 'generate-invoice',

  // Reports
  REPORT_SALES = 'reports/sales',
  REPORT_DUES = 'reports/dues',
  REPORT_ACCOUNT_SUMMARY = 'reports/account-summary',
  REPORT_ACCOUNT_STATEMENT = 'reports/account-statement',
  REPORT_CASH_COLLECTION = 'reports/cash-collection',
  DASHBOARD = 'dashboard',

  // Referential integrity
  CHECK_DELETE = 'check-delete',

  // Staff
  STAFF_USERS = 'staff-users',
  SAVE_STAFF_USER = 'save-staff-user',
  DELETE_STAFF_USER = 'delete-staff-user',
}
